

const FeatureTexts = [
  // <>
  //   <p className="text-[40px] text-white font-pop font-semibold xsm:text-[8px] sm:text-[16px] md:text-[20px] lg:text-[24px]">
  //           <span style={{ color: "#33EFA0", fontWeight: "bold" }}>
  //           Real-World Experience
  //     </span>{" "}
  //   </p>
  //   <div className="flex flex-col gap-4 mt-2 xsm:gap-1 xsm:mt-0 sm:gap-2">
  //     <div className="flex flex-row gap-10 justify-between items-center xsm:gap-2 sm:gap-4 md:gap-5 lg:gap-6">
  //       <div className="bg-[#ffffff] shadow-xl rounded-full w-[90px] h-[50px] flex justify-center items-center xsm:w-[40px] xsm:h-[16px] sm:w-[46px] sm:h-[22px] md:w-[52px] md:h-[24px] lg:w-[56px] lg:h-[28px]">
  //         <img src={Img1} className="w-[28px] h-[26px] xsm:w-[8px] xsm:h-[8px] sm:w-[10px] sm:h-[10px] md:w-[12px] md:h-[12px] lg:w-[14px] lg:h-[14px]" />
  //       </div>
  //       <p className="text-white text-[20px] font-pop xsm:text-[6px] sm:text-[8px] md:text-[10px] lg:text-[14px]">
  //       Our partnerships with leading MNC's provide students with access to world-class training programs and resources.
  //       </p>
  //     </div>
  //     <div className="flex flex-row gap-10 items-center xsm:gap-2 sm:gap-4 md:gap-5 lg:gap-6">
  //       <div className="bg-[#ffffff] shadow-xl rounded-full w-[95px] h-[50px] flex justify-center items-center xsm:w-[44px] xsm:h-[16px] sm:w-[50px] sm:h-[22px] md:w-[54px] md:h-[24px] lg:w-[58px] lg:h-[28px]">
  //         <img src={Img2} className="w-[30px] h-[26px] xsm:w-[8px] xsm:h-[8px] sm:w-[10px] sm:h-[10px] md:w-[12px] md:h-[12px] lg:w-[14px] lg:h-[14px]" />
  //       </div>
  //       <p className="text-white text-[20px] font-pop xsm:text-[6px] sm:text-[8px] md:text-[10px] lg:text-[14px]">
  //       Connect with industry leaders, gain insider insights, and stay ahead of the competition with our MNC-led upskilling initiatives.
  //       </p>
  //     </div>
  //     <div className="flex flex-row gap-10 items-center xsm:gap-2 sm:gap-4 md:gap-5 lg:gap-6">
  //       <div className="bg-[#ffffff] shadow-xl rounded-full w-[95px] h-[50px] flex justify-center items-center xsm:w-[40px] xsm:h-[16px] sm:w-[46px] sm:h-[22px] md:w-[52px] md:h-[24px] lg:w-[56px] lg:h-[28px]">
  //         <img src={Img3} className="w-[30px] h-[26px] xsm:w-[8px] xsm:h-[8px] sm:w-[10px] sm:h-[10px] md:w-[12px] md:h-[12px] lg:w-[14px] lg:h-[14px]" />
  //       </div>
  //       <p className="text-white text-[20px] font-pop xsm:text-[6px] sm:text-[8px] md:text-[10px] lg:text-[14px]">
  //       Experience transformative learning designed to prepare you for success in today's competitive job market.
  //       </p>
  //     </div>
  //     <div className="flex flex-row gap-10 items-center xsm:gap-2 sm:gap-4 md:gap-5 lg:gap-6">
  //       <div className="bg-[#ffffff] shadow-xl rounded-full w-[75px] h-[50px] flex justify-center items-center xsm:w-[35px] xsm:h-[16px] sm:w-[40px] sm:h-[22px] md:w-[46px] md:h-[24px] lg:w-[50px] lg:h-[28px]">
  //         <img src={Img3} className="w-[30px] h-[26px] xsm:w-[8px] xsm:h-[8px] sm:w-[10px] sm:h-[10px] md:w-[12px] md:h-[12px] lg:w-[14px] lg:h-[14px]" />
  //       </div>
  //       <p className="text-white text-[20px] font-pop xsm:text-[6px] sm:text-[8px] md:text-[10px] lg:text-[14px]">
  //       Unparalleled opportunities for upskilling with exclusive collaborations with top-tier MNC's
  //       </p>
  //     </div>
  //   </div>
  // </>,
  <>
    <p className="text-[40px] text-white font-pop font-semibold xsm:text-[10px] sm:text-[16px] md:text-[20px] lg:text-[24px]">
      <span style={{ color: "#33EFA0", fontWeight: "bold" }}>Real-World Experience</span>
    </p>
    <div className="flex flex-col gap-4 xsm:gap-1 sm:gap-2 md:gap-2">
      <p className="text-white text-[22px] font-pop leading-8 xsm:text-[6px] xsm:leading-3 sm:text-[10px] sm:leading-4 md:text-[12px] md:leading-5 lg:text-[14px] lg:leading-6">
      Our internship offers real industry exposure by engaging you in live projects and challenges, allowing you to apply what you learn directly to real-world tasks.
      Expert Mentorship      </p>
      {/* <p className="text-white text-[22px] font-pop leading-8 xsm:text-[6px] xsm:leading-3 sm:text-[10px] sm:leading-4 md:text-[12px] md:leading-5 lg:text-[14px] lg:leading-6">
      Curriculum emphasizes industry-relevant skills, project-based learning and internships, allowing students to build a strong foundation for their future careers.
      </p> */}
    </div>
  </>,
  <>
    <p className="text-[40px] text-white font-pop font-semibold xsm:text-[10px] sm:text-[16px] md:text-[20px] lg:text-[24px]">
      <span style={{ color: "#33EFA0", fontWeight: "bold" }}>
      Expert Mentorship
      </span>{" "}
      
    </p>
    <div className="flex flex-col gap-4">
      <p className="text-white text-[22px] font-pop leading-8 xsm:text-[6px] xsm:leading-3 sm:text-[10px] sm:leading-4 md:text-[12px] md:leading-5 lg:text-[14px] lg:leading-6">
      Get personalized guidance from industry experts who provide feedback and support to help you refine your skills and become corporate-ready.      </p>
    </div>
  </>,
    <>
    <p className="text-[40px] text-white font-pop font-semibold xsm:text-[10px] sm:text-[16px] md:text-[20px] lg:text-[24px]">
      <span style={{ color: "#33EFA0", fontWeight: "bold" }}>
      Skill Development Tools
      </span>{" "}
    </p>
    <div className="flex flex-col gap-4">
      <p className="text-white text-[22px] font-pop leading-8 xsm:text-[6px] xsm:leading-3 sm:text-[10px] sm:leading-4 md:text-[12px] md:leading-5 lg:text-[14px] lg:leading-6">
      Our program includes tools to help track your progress, improve your abilities, and ensure you are building job-relevant skills throughout the internship.      </p>
    </div>
  </>,
];

export default FeatureTexts;
